import { ApiError } from "../../api/client";

/** Сообщение для пользователя после неудачной отправки формы. */
export function formatSubmitError(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.errors) {
      const lines = Object.values(err.errors).flat().filter(Boolean);
      if (lines.length > 0) {
        return lines.join(" ");
      }
    }

    if (err.message && !err.message.startsWith("Request failed:")) {
      return err.message;
    }
  }

  return "Не удалось отправить форму. Попробуйте ещё раз.";
}
